'use client';

import { AnchorStep, anchorStepTag } from '@ni/nimble-components/dist/esm/anchor-step';
import { wrap } from '../utilities/react-wrapper';

export { anchorStepTag };
export { type AnchorStep };
export const NimbleAnchorStep = wrap(AnchorStep);
